var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStabilityGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 1512 970",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1261153571"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 6",
    x1: 145.5,
    y1: 970,
    x2: 145.5,
    y2: 6.09424,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 7",
    x1: 1365.5,
    y1: 970,
    x2: 1365.5,
    y2: 6.09424,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 8",
    x1: 1121.5,
    y1: 963.906,
    x2: 1121.5,
    y2: 2.77488e-8,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 9",
    x1: 877.5,
    y1: 970,
    x2: 877.5,
    y2: 6.09424,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 10",
    x1: 389.5,
    y1: 970,
    x2: 389.5,
    y2: 6.09424,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 15",
    x1: 633.5,
    y1: 966.953,
    x2: 633.5,
    y2: 3.04712,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 11",
    y1: 850.662,
    x2: 1512,
    y2: 850.662,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 16",
    y1: 661.741,
    x2: 1512,
    y2: 661.741,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 12",
    y1: 472.819,
    x2: 1512,
    y2: 472.819,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 13",
    y1: 283.898,
    x2: 1512,
    y2: 283.898,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 14",
    y1: 94.9764,
    x2: 1512,
    y2: 94.9764,
    stroke: "var(--stroke-0, white)",
    strokeOpacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStabilityGrid);
export default __webpack_public_path__ + "static/media/stability-grid.9dffd675b28663f7973cc699760e9f12.svg";
export { ForwardRef as ReactComponent };